import { camelCase } from '../util.js'
var works = [
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-0'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-01')
    ]
  },
  {
    title: '佰草集——遇爱 愈美丽',
    desc: '佰草集——遇爱 愈美丽',
    thumb: camelCase('cases-brand-herborist-1'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-11')
    ]
  },
  {
    title: '佰草集——古方之绽 请肌养颜',
    desc: '佰草集——古方之绽 请肌养颜',
    thumb: camelCase('cases-brand-herborist-2'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-21')
    ]
  },
  {
    title: '佰草集——瓷之釉润 肌之玉润',
    desc: '佰草集——瓷之釉润 肌之玉润',
    thumb: camelCase('cases-brand-herborist-3'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-31')
    ]
  },
  {
    title: '佰草集——美之以衡 焕若桃花',
    desc: '佰草集——美之以衡 焕若桃花',
    thumb: camelCase('cases-brand-herborist-4'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-41')
    ]
  },
  {
    title: '佰草集——新美肌 萃膜力',
    desc: '佰草集——新美肌 萃膜力',
    thumb: camelCase('cases-brand-herborist-5'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-51')
    ]
  },
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-6'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-61')
    ]
  },
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-7'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-71')
    ]
  },
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-8'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-81')
    ]
  },
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-9'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-91')
    ]
  },
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-10'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-101')
    ]
  },
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-11'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-111')
    ]
  },
  {
    title: '佰草集——白若凝脂 如瓷美肌',
    desc: '佰草集——白若凝脂 如瓷美肌',
    thumb: camelCase('cases-brand-herborist-12'),
    zpic: [
      camelCase('cases-brand-herborist-lazyload-121')
    ]
  }
]
export default {
  name: '佰草集',
  logo: {
    default: camelCase('cases-brand-10'),
    active: camelCase('cases-brand-10-cover')
  },
  works
}
